import { combineReducers } from "redux";
import { CombinedReducersType } from "@type/index";
import imageSearchReducer, {
  Actions as ImageSearchActions,
  SET_SEARCH_IMAGE
} from "./imageSearch";
import favoritesItemReducer, {
  Actions as FavoritesItemActions
} from "./favoritesItem";
import searchResultReducer, {
  Actions as SearchResultActions,
  FETCH_VISUAL_SERCH,
  FETCH_VISUAL_SERCH_SUCCESS,
  FETCH_PRODUCTS,
  FETCH_OUTFITS
} from "./searchResult";
import appReducer, {
  Actions as AppActions,
  SET_LANGUAGE_REGION,
  SET_ERROR_FLAG,
  SET_LOGIN_FLAG
} from "./app";
import feedbackReducer, { Actions as FeedbackActions } from "./feedback";

const rootReducer = combineReducers<CombinedReducersType>({
  app: appReducer,
  favoritesItem: favoritesItemReducer,
  imageSearch: imageSearchReducer,
  searchResult: searchResultReducer,
  feedback: feedbackReducer
});

export default rootReducer;

export {
  ImageSearchActions,
  SET_SEARCH_IMAGE,
  FavoritesItemActions,
  SearchResultActions,
  FETCH_VISUAL_SERCH,
  FETCH_VISUAL_SERCH_SUCCESS,
  FETCH_PRODUCTS,
  FETCH_OUTFITS,
  AppActions,
  FeedbackActions,
  SET_LANGUAGE_REGION,
  SET_ERROR_FLAG,
  SET_LOGIN_FLAG
};
